import TabButton from './tab_button';
import { useAuth, ROLES } from '../contexts/AuthContext';

function Tabbar({ activeTab, setActiveTab }) {
  const { role } = useAuth();
  const isVisitor = role === ROLES.VISITOR;
  const isGuest = role === ROLES.GUEST;

  return (
    <div className="flex bg-orange-50 border-b border-orange-200">
      <TabButton
        label="지도로 보기"
        isActive={activeTab === 'map'}
        onClick={() => setActiveTab('map')}
      />
      <TabButton
        label="목록으로 보기"
        isActive={activeTab === 'list'}
        onClick={() => !isVisitor && setActiveTab('list')}
        disabled={isVisitor}
      />
      <TabButton
        label="상담 및 관리"
        isActive={activeTab === 'consultation'}
        onClick={() => !isVisitor && !isGuest && setActiveTab('consultation')}
        disabled={isVisitor || isGuest}
      />
    </div>
  );
}

export default Tabbar;